if (customElements.get("product-swatches")) {} else {
    class ProductSwatches extends HTMLElement {
        constructor() {
            super();
            this.titleEl = null;
            this.originalTitle = "";
            this.swatches = [];
        }
        connectedCallback() {
            this.titleEl = this.querySelector("[data-active-title]");
            this.originalTitle = this.titleEl?.textContent?.trim() ?? "";
            this.swatches = Array.from(this.querySelectorAll("[data-swatch]"));
            this.swatches.forEach(swatch => {
                swatch.addEventListener("mouseenter", () => {
                    if (this.titleEl && swatch.dataset.swatchTitle) this.titleEl.textContent = swatch.dataset.swatchTitle;
                });
                swatch.addEventListener("mouseleave", () => {
                    if (this.titleEl) this.titleEl.textContent = this.originalTitle;
                });
            });
        }
        disconnectedCallback() {
            this.swatches.forEach(swatch => {
                swatch.removeEventListener("mouseenter", void 0);
                swatch.removeEventListener("mouseleave", void 0);
            });
        }
    }
    customElements.define("product-swatches", ProductSwatches);
}